/*
 * Description:
 * ---------------------
 * Needs you: the changes an AI agent asked for that wait for this person's
 * yes, one line each at the top of every console screen, each opening its
 * approval page (ApprovalPage). useWaiting reads them for the strip and for
 * the approval screen's list, once for both. A server without approvals, or
 * one that does not answer, shows no strip: the approval screen says why.
 * All wording is in approvalWords.js.
 *
 * ! file components/NeedsYou.js
 */
import React, { useCallback, useState } from "react";
import useVisibleInterval from "../hooks/useVisibleInterval";
import { NotServed, ROUTES, ask } from "./approvalApi";
import * as W from "./approvalWords";
import "./Approvals.css";

const READ_MS = 15000;
const SHOWN = 3;

/* useWaiting is what waits for this person: what nobody has decided, at an
   organisation whose approver list names them (you, by organisation), and
   they have not said yes to yet. Null until the server first answers; error
   says why it did not ("unserved" for a server without approvals). */
export function useWaiting(serverApiUrl, enabled) {
  const [state, setState] = useState({ approvals: null, error: "" });
  const read = useCallback(() => ask(serverApiUrl, ROUTES.waiting)
    .then((out) => {
      const you = out.you || {};
      const mine = (out.approvals || []).filter((a) => a.status === "waiting" && you[a.customer] && !W.saidYes(a, you[a.customer]));
      setState({ approvals: mine, error: "" });
    })
    .catch((e) => setState((s) => ({ ...s, error: e instanceof NotServed ? "unserved" : e.message }))), [serverApiUrl]);
  useVisibleInterval(read, READ_MS, enabled);
  return { ...state, refresh: read };
}

export default function NeedsYou({ approvals, onOpen }) {
  if (!approvals?.length) return null;
  const now = new Date();
  return (
    <div className="needs-you" role="region" aria-label={W.NEEDS_YOU}>
      {approvals.slice(0, SHOWN).map((a) => {
        const { where, what } = W.brief(a);
        const left = W.timeLeft(a.expires, now);
        return (
          <button key={a.id} type="button" className="needs-you-item" onClick={() => onOpen(a.id)}>
            <span><b>{W.NEEDS_YOU} at {where}:</b> {what}. {left && <span className="needs-you-left">{W.cap(left)}.</span>}</span>
            <span className="needs-you-go"><span className="needs-you-look">{W.LOOK}</span> ›</span>
          </button>
        );
      })}
      {approvals.length > SHOWN && (
        <button type="button" className="needs-you-item" onClick={() => onOpen("")}>
          <span>{W.andMore(approvals.length - SHOWN)}.</span>
          <span className="needs-you-go"><span className="needs-you-look">{W.LOOK}</span> ›</span>
        </button>
      )}
    </div>
  );
}
